/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const BankAccountVerificationMethod = {
  Instant: "instant",
  Ach: "ach",
} as const;
export type BankAccountVerificationMethod = ClosedEnum<
  typeof BankAccountVerificationMethod
>;

/** @internal */
export const BankAccountVerificationMethod$inboundSchema: z.ZodNativeEnum<
  typeof BankAccountVerificationMethod
> = z.nativeEnum(BankAccountVerificationMethod);
/** @internal */
export const BankAccountVerificationMethod$outboundSchema: z.ZodNativeEnum<
  typeof BankAccountVerificationMethod
> = BankAccountVerificationMethod$inboundSchema;
